module.exports = __webpack_public_path__ + "img/qr17.5c9371b1.webp";